<template>
  <div class="app-container" id="xmcheck">
    <div class="mycontainer" style="margin-bottom: 10px">
      <el-form ref="queryForm" :model="queryParams" :inline="true">
        <el-form-item label="配置类型">
          <el-select
            v-model="queryParams.pzlx"
            placeholder="全部"
            filterable
            clearable
            size="small"
            style="width: 200px"
            class="filter-item"
          >
            <el-option
              v-for="item in pzlx"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            ></el-option>
          </el-select>
        </el-form-item>

        <el-form-item label="产品条线">
          <el-select
            v-model="queryParams.line"
            placeholder="全部"
            filterable
            clearable
            size="small"
            style="width: 200px"
            class="filter-item"
          >
            <el-option
              v-for="item in line"
              :key="item.dictValue"
              :label="item.dictLabel"
              :value="item.dictValue"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="被分配人">
          <treeselect
            v-model="queryParams.ygbhs"
            :multiple="true"
            placeholder="请选择"
            :options="deptUser"
            :disable-branch-nodes="true"
            :show-count="true"
            value-consists-of="LEAF_PRIORITY"
            no-results-text="未搜到任何结果"
            :clear-on-select="true"
            :normalizer="normalizer"
            style="width: 270px; line-height: 15px; margin-top: 3px"
            :limit="1"
            :max-height="200"
          />
        </el-form-item>
        <span style="margin-top: 4px; display: inline-block">
          <el-button
            type="primary"
            icon="el-icon-search"
            size="small"
            @click="handleQuery"
            >查询</el-button
          >
          <el-button
            type="primary"
            icon="el-icon-plus"
            size="small"
            @click="addDialog = true"
            >新增</el-button
          >
        </span>
      </el-form>
    </div>

    <div class="mycontainer">
      <el-table
        v-loading="loading"
        :data="userManageList"
        fit
        :header-cell-style="tableHeaderColor"
        :max-height="height"
        :default-sort="{ prop: 'date', order: 'descending' }"
        tooltip-effect="dark"
      >
        <el-table-column
          label="操作"
          min-width="90"
          align="center"
          class-name="small-padding fixed-width"
        >
          <template slot-scope="scope">
            <el-button size="mini" type="text" @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <el-button
              size="mini"
              type="text"
              @click="handleDelete(scope.row.id)"
              >删除</el-button
            >
          </template>
        </el-table-column>
        <el-table-column
          align="left"
          label="类型id"
          prop="id"
          min-width="70px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          align="left"
          label="配置类型"
          prop="pzlx"
          min-width="200px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="产品条线"
          prop="line"
          align="left"
          min-width="200px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          label="被分配人"
          prop="ygbh"
          align="left"
          min-width="200px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          align="left"
          label="创建人"
          prop="createBy"
          min-width="100px"
          :show-overflow-tooltip="true"
        />
        <el-table-column
          align="left"
          label="创建时间"
          prop="createTime"
          min-width="100px"
          :show-overflow-tooltip="true"
        />
        <template slot="empty">
          <div class="nodata">
            <img src="@/img/nodata.png" alt="" width="160" />
            <div>暂无数据</div>
          </div>
        </template>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="[10, 20, 30, 40]"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
      ></el-pagination>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="新增人员配置"
      :visible.sync="addDialog"
      width="800px"
      v-if="addDialog"
      id="mx-dialog"
    >
      <Add ref="add" @giveFather="getSon"></Add>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSaveAdd">确定</el-button>
        <el-button @click="addDialog = false">取消</el-button>
      </div>
    </el-dialog>

    <el-dialog
      :close-on-click-modal="false"
      :close-on-press-escape="false"
      title="编辑人员配置"
      :visible.sync="editDialog"
      width="700px"
      v-if="editDialog"
      id="mx-dialog"
    >
      <Edit ref="edit" :mxParams="mxParams" @giveFather="getSon"></Edit>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="handleSaveEdit">确定</el-button>
        <el-button @click="editDialog = false">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
    
  <script>
import {
  getUserManageList,
  deleteUserManage,
  selectDictDataByType,
} from "@/api/userManage.js";
import Treeselect from "@riophae/vue-treeselect";
import "@riophae/vue-treeselect/dist/vue-treeselect.css";
import { mapGetters } from "vuex";
import Add from "./add.vue";
import Edit from "./edit.vue";
export default {
  components: { Treeselect, Add, Edit },
  data() {
    return {
      normalizer(node) {
        return {
          children: node.users,
        };
      },
      loading: true,
      height: 100,
      queryParams: {
        ygbhs: [],
      },
      page: 1,
      pageSize: 10,
      total: 0,
      userManageList: [],
      line: [],
      pzlx: [],
      xzrList: [],
      addDialog: false,
      editDialog: false,
      mxParams: {},
    };
  },
  computed: {
    ...mapGetters(["deptUser", "user", "task"]),
  },
  created() {
    if (!this.deptUser || this.deptUser.length == 0) {
      this.$store.dispatch("common/getDeptUser");
    }
    this.$store.dispatch("common/fetchUserInfoAction");
    this.getlist();
    this.select();
  },

  methods: {
    getlist() {
      getUserManageList(this.queryParams, this.page, this.pageSize).then(
        (res) => {
          this.loading = false;
          if (res.code == 0) {
            this.userManageList = res.data;
            this.total = res.count;
            const docH = document.documentElement.clientHeight;
            const mycontainerH =
              document.querySelector(".mycontainer").clientHeight;
            this.height = docH - mycontainerH - 70;
          }
        }
      );
    },
    select() {
      selectDictDataByType("pmp_quality_line", 1).then((res) => {
        if (res.code == 0) {
          this.line = res.data;
        }
      });
      selectDictDataByType("pmp_rypz_lx", 1).then((res) => {
        if (res.code == 0) {
          this.pzlx = res.data;
        }
      });
    },
    handleQuery() {
      this.getlist();
    },
    handleDelete(id) {
      this.$confirm("是否确认删除?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(function () {
          return deleteUserManage(id);
        })
        .then((res) => {
          if (res.code == 0) {
            this.getlist();
            this.$notify({
              title: "成功",
              message: "删除成功",
              type: "success",
              duration: 2000,
            });
          } else {
            this.$notify({
              title: "失败",
              message: res.msg,
              type: "error",
              duration: 2000,
            });
          }
        })
        .catch(() => {});
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getlist();
    },
    handleCurrentChange(val) {
      this.page = val;
      this.getlist();
    },
    handleSaveAdd() {
      this.$refs.add.handleAdd();
      setTimeout(() => {
        this.getlist();
      }, 500);
    },
    handleEdit(row) {
      this.editDialog = true;
      this.mxParams = row;
    },
    handleSaveEdit() {
      this.$refs.edit.handleEdit();
      setTimeout(() => {
        this.getlist();
      }, 500);
    },
    getSon(temp) {
      this.addDialog = temp;
      this.editDialog = temp;
    },
    tableHeaderColor({ row, column, rowIndex, columnIndex }) {
      if (rowIndex === 0) {
        return "background-color: #f2f2f2;";
      }
    },
  },
};
</script>
    <style lang="less" scoped>
.app-container {
  padding: 10px;
  height: 100%;
  width: 100%;
  background-color: #fff;
  box-sizing: border-box;
  padding-bottom: 0;
}
.mycontainer {
  padding: 10px;
  background-color: #fff;
  border-radius: 6px;
  box-sizing: border-box;
  padding-bottom: 0;
}
.filter-container {
  padding: 0;
}
.search-container {
  border: 0;
}
::v-deep #dic-form .el-form-item {
  margin-bottom: 0;
}
.el-form-item {
  margin-bottom: 22px;
}
</style>
  